import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const CustomSelect = ({ children, label, instanceFormik, name, onChange,required= false }) => {
    children = !children ? [] : children;
    onChange = !onChange ? instanceFormik.handleChange : onChange;
    const selectedValue = instanceFormik.values[name] || ``; 
    return (
        <FormControl fullWidth size="small" sx={{ marginBottom: 2 }}>
            <InputLabel
                sx={{
                    color: instanceFormik.touched[name] && instanceFormik.errors[name] ? "red" : "",
                }}
            >
                {instanceFormik.touched[name] && instanceFormik.errors[name]
                ? instanceFormik.errors[name]
                : `${label} ${required ? "*" : ""}`}
            </InputLabel>
            <Select
                name={name}
                label={
                    instanceFormik.touched[name] && instanceFormik.errors[name]
                    ? instanceFormik.errors[name]
                    : `${label} ${required ? "*" : ""}`
                }
                value={selectedValue}
                onChange={onChange}
                onBlur={instanceFormik.handleBlur}
                error={instanceFormik.touched[name] && instanceFormik.errors[name] ? true : false}
            >
                {/* <MenuItem value="">None</MenuItem> */}
                {children.map((child) => (
                    <MenuItem key={child.id} value={child.id}>
                        {child.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}


export default CustomSelect;